import { render, staticRenderFns } from "./NewsContent.vue?vue&type=template&id=71a9ea8e&scoped=true&"
import script from "./NewsContent.vue?vue&type=script&lang=js&"
export * from "./NewsContent.vue?vue&type=script&lang=js&"
import style0 from "./NewsContent.vue?vue&type=style&index=0&id=71a9ea8e&scoped=true&lang=css&"
import style1 from "./NewsContent.vue?vue&type=style&index=1&lang=css&"
import style2 from "assets/css/ckeditor.css?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a9ea8e",
  null
  
)

export default component.exports